import { FiscalpopCFDI } from '../../models/Factura';
import { endpoints } from './endpoints';
import { request } from './http';

export interface CfdiCancelStatus {
    toCancelProcess: 'Cancelable sin aceptación' | 'Cancelable con aceptación' | 'No Cancelable';
    estado: boolean;
    cancelStatus: string;
}

export const cfdi = {
    findByDateRange(
        startMs: number,
        endMs: number,
        opts?: { conceptos?: boolean; impuestos?: boolean; signal?: AbortSignal }
    ): Promise<FiscalpopCFDI[]> {
        const { signal, ...rest } = opts ?? {};
        const flags: Record<string, boolean> = {};
        Object.entries(rest).forEach(([k, v]) => {
            if (v !== undefined) flags[k] = v;
        });
        return request<FiscalpopCFDI[]>(endpoints.cfdi.findBy(startMs, endMs, flags), {
            signal,
        });
    },
    findByUuid(uuid: string): Promise<FiscalpopCFDI[]> {
        return request<FiscalpopCFDI[]>(endpoints.cfdi.find(uuid));
    },
    getCancelStatus(uuid: string): Promise<CfdiCancelStatus> {
        return request<CfdiCancelStatus>(endpoints.cfdi.status(uuid));
    },
};
